import { render, staticRenderFns } from "./ConfirmarAcessoExterno.vue?vue&type=template&id=4cf08a1a"
import script from "./ConfirmarAcessoExterno.vue?vue&type=script&lang=js"
export * from "./ConfirmarAcessoExterno.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarAcessoExterno.vue?vue&type=style&index=0&id=4cf08a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports